import permissions from '@/constants/permissions'

const NextEditionGuardianConsentPreview = () =>
  import('@/views/nextEditionDocument/NextEditionGuardianConsentPreview.vue')

export default {
  path: 'zgoda',
  name: 'NextEditionApplication',
  component: NextEditionGuardianConsentPreview,
  meta: {
    requireAuth: true,
    permission: [
      permissions.nextEditionRecommendationAdd,
      permissions.nextEditionRecommendationView
    ]
  }
}
